import { Button, Img, Line, Text } from "components";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import OccasionDetailBox from "./OccasionDetailBox";
import { AddToMyOccasionAddNew } from "popups/AddToMyOccasionAddNew";
import { DeleteModal } from "popups/DeleteModal";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import * as CUSTOM from "../../../../utils/helper/custom";
import { CART, OCCASION } from "../../../../utils/helper/Enum";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import { useNavigate } from "react-router-dom";
import EmptyAll from "../../../EmptyList";
import { changeTrigger } from "redux/reducers/trigger";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../../utils/global/localData";
// function createData(Occasion, Relation, OccasionType, OccasionDate, protein) {
//   return { Occasion, Relation, OccasionType, OccasionDate, protein };
// }

const MyOccasions = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rows, setRow] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [editData, setEditdata] = useState({});
  const [drawerData, setdrawerData] = useState({ data: [], detail: null });
  const [AddToMyOccasionAddNewOpen, setAddToMyOccasionAddNewOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  
  // Three dot menu state
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const menuOpen = Boolean(anchorEl);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // Handle three dot menu open
  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  // Handle three dot menu close
  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  // Handle edit from menu
  const handleEditClick = () => {
    if (selectedRow) {
      setEditdata({
        id: selectedRow?.id,
        name: selectedRow.name,
        date: selectedRow?.date,
        occasion_type_id: selectedRow?.occasionType?.id,
        relation_id: selectedRow?.relation?.id,
        edit: "yes",
      });
      handelAddToMyOccasionAddEdit();
    }
    handleMenuClose();
  };

  // Handle delete from menu
  const handleDeleteClick = () => {
    if (selectedRow) {
      setDeleteId(selectedRow?.id);
      handelsetDeleteModalOpen();
    }
    handleMenuClose();
  };

  // Get initials for avatar
  const getInitials = (name) => {
    if (!name) return "OC";
    const words = name.split(" ");
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Get random color for avatar
  const getAvatarColor = (index) => {
    const colors = [
      "bg-red-100 text-red-600",
      "bg-blue-100 text-blue-600",
      "bg-green-100 text-green-600",
      "bg-yellow-100 text-yellow-600",
      "bg-purple-100 text-purple-600",
      "bg-pink-100 text-pink-600",
    ];
    return colors[index % colors.length];
  };

  /**
   * get all occasion
   */
  const getAllOccasion = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        OCCASION?.LISTING,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setRow(response?.data?.data);
        setIsEmpty(false);
      } else {
        setIsEmpty(true);
      }
    } catch (e) {
      setIsEmpty(true);
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  const deleteData = (deleteId) => {
    const updatedData = rows.filter((item) => item.id !== deleteId);
    if (updatedData.length == 0) {
      setIsEmpty(true);
    }
    setRow(updatedData);
    dispatch(changeLoader(false));
  };

  /**
   * delete confirm
   */
  const deleteConfirm = async (type) => {
    if (type == "yes" && deleteId != 0) {
      dispatch(changeLoader(true));
      try {
        let response = await globalRequest(
          OCCASION?.UPDATE_OCCASION_STATUS,
          "put",
          { id: deleteId, status: "deleted" },
          {},
          true
        );
        response = response?.data;
        if (response?.status == "SUCCESS") {
          //getAllOccasion();
          deleteData(deleteId);
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "success",
            })
          );
        }
      } catch (e) {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: e?.message,
            snackbarState: "error",
          })
        );
        dispatch(changeLoader(false));
      }
    } else {
      setDeleteId(0);
    }
  };

  const handelAddToMyOccasionAddNew = () => {
    setEditdata({});
    setAddToMyOccasionAddNewOpen(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  const handelAddToMyOccasionAddEdit = () => {
    setAddToMyOccasionAddNewOpen(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  const [DeleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const handelsetDeleteModalOpen = () => {
    setDeleteModalOpen(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  /**
   *  Get occassion products
   */
  const getOccasionProducts = async (id, detail = {}) => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        `${OCCASION?.GET_OCCASION_PRODUCT_BY_ID}/${id}`,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setdrawerData({ data: response?.data, detail: detail });
      } else {
        setdrawerData({ data: [], detail: detail });
      }
      setOpen(true);
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  /**
   *  Delete item by id
   */
  const deleteItem = async (id = 0) => {
    try {
      let response = await globalRequest(
        `${CART?.DELETE_BY_ITEM_ID}/${id}`,
        "delete",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        if (drawerData?.detail?.id) {
          getOccasionProducts(drawerData?.detail?.id, drawerData?.detail);
        }
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /**
   * place order or add to cart data
   */
  const placeOrder = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        `${OCCASION?.PLACE_ORDER}/${drawerData?.data?.occasionId}`,
        "post",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        dispatch(changeTrigger("fetchCartCount"));
        navigate("/cart"); 
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      } 
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      ); 
    } 
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    if (rows.length > 0) {
      let tabName = addDeleteGetLocalStorage(storageKeys.ORDER_TAB, {}, "get");
      let tabId = addDeleteGetLocalStorage(storageKeys.ORDER_TAB_ID, {}, "get");
      if (tabName && tabId) {
        if (tabName == "occasion") {
          let rowdata = rows?.find((item) => item?.id == tabId);
          if (rowdata) {
            addDeleteGetLocalStorage(storageKeys.ORDER_TAB, {}, "delete");
            addDeleteGetLocalStorage(storageKeys.ORDER_TAB_ID, {}, "delete");
            getOccasionProducts(rowdata?.id, rowdata);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);
  
  useEffect(() => {
    getAllOccasion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (AddToMyOccasionAddNewOpen == "refetch") {
      getAllOccasion();
      setAddToMyOccasionAddNewOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AddToMyOccasionAddNewOpen]);

  return (
    <>
      <div className="flex flex-row font-nunitomedium items-center justify-between w-full mb-7">
        <Text
          className="text-[24px] md:text-[20px] text-black-900 sm:text-xl font-['Inter'] font-medium"
        >
          {t("myOccasions")}
        </Text>
        <Button
          className="min-w-[125px] flex items-center justify-center rounded-full"
          size="md"
          variant="OutlineBlack"
          onClick={handelAddToMyOccasionAddNew}
          hover={true}
          hoverclass="bg-pink-300"
        >
          <Text
            as="span"
            className="mx-2 text-center text-[14px] font-medium leading-[20px] text-[#1A1A1A]"
            style={{ fontFamily: "Unbounded" }}
          >
            {t("newOccasion")}
          </Text>
        </Button>
      </div>
      
      {!isEmpty ? (
        <>
          {/* Card Based Design */}
          <div className="flex flex-col gap-4 w-full">
            {rows.map((row, index) => (
              <div
                key={row.id}
                className="bg-white-A700 rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow cursor-pointer relative"
                onClick={(e) => {
                  if (!e.defaultPrevented) {
                    getOccasionProducts(row?.id, row);
                  }
                }}
              >
                <div className="flex items-center gap-4 w-full">
                  {/* Avatar */}
                  <div className={`w-10 h-10 rounded-full font-[Inter] flex items-center justify-center text-sm font-medium ${getAvatarColor(index)}`}>
                    {getInitials(row.name)}
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <Text
                      className="text-base text-[14px] text-black-900 font-medium font-['Unbounded']"
                    >
                      {row.name}
                    </Text>
                    <div className="flex items-center gap-2 mt-1">
                      <Text
                        className="text-sm text-[#727783] font-['Inter']"
                      >
                        {CUSTOM.getdataByLangKey(
                          row?.occasionType?.occasionTypeLocales,
                          "",
                          "name"
                        )}
                      </Text>
                      <span className="text-gray-400">•</span>
                      <Text
                        className="text-sm text-[#727783] font-['Inter']"
                      >
                        {CUSTOM.getdataByLangKey(
                          row?.relation?.relationLocales,
                          "",
                          "name"
                        )}
                      </Text>
                      <span className="text-gray-400">•</span>
                      <Text
                        className="text-sm text-[#727783] font-['Inter']"
                      >
                        {row.date
                          ? CUSTOM.changeDateFormat(row?.date, "dd/MM/yyyy")
                          : ""}
                      </Text>
                    </div>
                  </div>

                  {/* Three Dot Menu */}
                  <div
                    className="cursor-pointer p-2 border border-[#E6E6E6] hover:bg-gray-100 rounded-full transition-colors"
                    onClick={(e) => handleMenuClick(e, row)}
                  >
                    <Img
                      src="/images/threeDot.svg"
                      className="w-5 h-5"
                      alt="more"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Three Dot Menu */}
          <Menu
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              style: {
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                minWidth: '150px',
              },
            }}
          >
            <MenuItem 
              onClick={handleEditClick}
              style={{ 
                padding: '10px 16px',
                fontSize: '14px',
                fontFamily: 'Inter',
              }}
            >
              <Img
                src="/images/img_edit_black_900.svg"
                className="w-4 h-4 mr-2"
                alt="edit"
              />
              <span className="font-[Inter]">{t("edit")}</span>
            </MenuItem>
            <MenuItem 
              onClick={handleDeleteClick}
              style={{ 
                padding: '10px 16px',
                fontSize: '14px',
                fontFamily: 'Inter',
                color: '#EF4444',
              }}
            >
              <Img
                src="/images/img_trash.svg"
                className="w-4 h-4 mr-2"
                alt="delete"
              />
              <span className="font-[Inter]">{t("delete")}</span>
            </MenuItem>
          </Menu>

          {/* <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("occasion")}</TableCell>
                  <TableCell>{t("relation")}</TableCell>
                  <TableCell>{t("occasionType")}</TableCell>
                  <TableCell>{t("occasionDate")}</TableCell>
                  <TableCell>{""}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.Occasion}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      className="cursor-pointer"
                      onClick={(e) => {
                        getOccasionProducts(row?.id, row);
                      }}
                    >
                      {row.name}
                    </TableCell>
                    <TableCell>
                      {CUSTOM.getdataByLangKey(
                        row?.relation?.relationLocales,
                        "",
                        "name"
                      )}
                    </TableCell>
                    <TableCell>
                      {CUSTOM.getdataByLangKey(
                        row?.occasionType?.occasionTypeLocales,
                        "",
                        "name"
                      )}
                    </TableCell>
                    <TableCell>
                      {row.date
                        ? CUSTOM.changeDateFormat(row?.date, "dd/MM/yyyy")
                        : ""}
                    </TableCell>
                    <TableCell>
                      <div className="flex flex-row items-center justify-end">
                        <Img
                          src="/images/img_edit_black_900.svg"
                          className={"cursor-pointer w-5 h-5 mx-3"}
                          alt="edit"
                          onClick={(e) => {
                            setEditdata({
                              id: row?.id,
                              name: row.name,
                              date: row?.date,
                              occasion_type_id: row?.occasionType?.id,
                              relation_id: row?.relation?.id,
                              edit: "yes",
                            });
                            handelAddToMyOccasionAddEdit();
                          }}
                        />
                        <Img
                          src="/images/img_trash.svg"
                          className={"cursor-pointer w-5 h-5"}
                          alt="delete"
                          onClick={() => {
                            setDeleteId(row?.id);
                            handelsetDeleteModalOpen();
                          }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer> */}

          <SwipeableDrawer
            anchor="right"
            open={open}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
          >
            <div className="w-[450px] xs:w-full px-[35px] sm:px-4 py-8 sm:py-4 before-pink-round">
              <div className="flex flex-row gap-3 items-center justify-start w-full mb-8 sm:mb-4">
                <Img
                  className="h-6 w-6 cursor-pointer"
                  src="/images/img_close_black_900.svg"
                  alt="close"
                  onClick={toggleDrawer(false)}
                />
                <Text
                  className="text-2xl md:text-[22px] text-black-900 sm:text-xl"
                  size="txtnunitoSemiBold24"
                >
                  {drawerData?.detail?.name}
                </Text>
              </div>
              <div className="flex flex-row items-start justify-between mt-[22px] w-full">
                <div className="flex flex-col gap-1 items-start justify-start">
                  <Text
                    className="text-base text-black-900"
                    size="txtnunitoMedium16"
                  >
                    {t("relation")}
                  </Text>
                  <Text
                    className="text-base text-gray-700"
                    size="txtnunitoRegular16Gray700"
                  >
                    {CUSTOM.getdataByLangKey(
                      drawerData?.detail?.relation?.relationLocales,
                      "en",
                      "name"
                    )}
                  </Text>
                </div>
                <Line className="bg-gray-300 h-8 my-2 w-px" />
                <div className="flex flex-col gap-1 items-start justify-start">
                  <Text
                    className="text-base text-black-900"
                    size="txtnunitoMedium16"
                  >
                    {t("occasionType")}
                  </Text>
                  <Text
                    className="text-base text-gray-700"
                    size="txtnunitoRegular16Gray700"
                  >
                    {CUSTOM.getdataByLangKey(
                      drawerData?.detail?.occasionType?.occasionTypeLocales,
                      "en",
                      "name"
                    )}
                  </Text>
                </div>
                <Line className="bg-gray-300 h-8 my-2 w-px" />
                <div className="flex flex-col gap-1 items-start justify-start">
                  <Text
                    className="text-base text-black-900"
                    size="txtnunitoMedium16"
                  >
                    {t("occasionDate")}
                  </Text>
                  <Text
                    className="text-base text-gray-700"
                    size="txtnunitoRegular16Gray700"
                  >
                    {drawerData?.detail?.date
                      ? CUSTOM.changeDateFormat(
                          drawerData?.detail?.date,
                          "dd/MM/yyyy"
                        )
                      : ""}
                  </Text>
                </div>
              </div>
              <Line className="bg-gray-300 h-px my-4 w-full" />
              {drawerData?.data.length != 0 &&
              drawerData?.data?.cartItems.length != 0 ? (
                <>
                  <Text
                    className="mt-[19px] text-gray-700 text-xs"
                    size="txtnunitoRegular12Gray700"
                  >
                    {drawerData?.data?.cartItems
                      ? drawerData?.data?.cartItems.length
                      : 0}{" "}
                    {t("items")}
                  </Text>
                  <div className="mt-[10px] w-full detail-box-height">
                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">
                      {drawerData?.data?.cartItems.map((items, index) => {
                        return (
                          <OccasionDetailBox
                            className=""
                            caketext={`${CUSTOM.getdataByLangKey(
                              items?.product?.productLocales,
                              "en",
                              "name"
                            )} - ${items?.productUom?.name}`}
                            image={`${
                              items?.productUom?.productUomImages?.[0]?.image ||
                              ""
                            }`}
                            itemId={items?.id}
                            delete={deleteItem}
                          />
                        );
                      })}
                    </div>
                  </div>
                  <div className="bg-white-A700 flex flex-col items-center justify-start p-4 shadow-bs7 w-full absolute left-0 right-0 bottom-0">
                    <Button
                      className="w-full"
                      variant={"FillBlack"}
                      size={"lg"}
                      onClick={(e) => {
                        placeOrder();
                      }}
                    >
                      {t("placeOrder")}
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center w-full">
                    <Img
                      className="h-[140px] w-[140px] mt-14 mx-auto"
                      src="/images/img_package011.svg"
                      alt="package011"
                    />
                    <Text
                      className="mt-3 text-base text-black-900 text-center"
                      size="txtnunitoMedium16"
                    >
                      {t("noItems")}
                    </Text>
                    <Text
                      className="mt-3 text-center text-gray-700 text-xs text-center"
                      size="txtnunitoRegular12Gray700"
                    >
                      {t("currentlyNoItemsAddedYetInThisOccassionDot")}
                    </Text>
                    <Button
                      className="w-[180px] mx-auto mt-10"
                      variant={"FillBlack"}
                      size={"md"}
                      onClick={(e) => {
                        navigate("/all-products");
                      }}
                    >
                      {t("addNow")}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </SwipeableDrawer>
        </>
      ) : (
        <EmptyAll type="occasion"></EmptyAll>
      )}

      {AddToMyOccasionAddNewOpen === true ? (
        <AddToMyOccasionAddNew
          editData={editData}
          closepopup={setAddToMyOccasionAddNewOpen}
          modalTopIcon="/images/add_to-occasion-icon.svg"
          OccasionTitle={
            Object.keys(editData).length == 0
              ? t("addNewOccasion")
              : t("UpdateOccasion")
          }
          OccasionParagraph={t("enterBelowDetailsToAddANewOccasionDot")}
        />
      ) : null}
      {DeleteModalOpen === true ? (
        <DeleteModal
          deleteTitle={t("deleteOccasion")}
          deleteParagraph={t(
            "areYouSureYouWantToDeleteThisOccasionQuestionMark"
          )}
          closepopup={setDeleteModalOpen}
          deleteConfirm={deleteConfirm}
        />
      ) : null}
    </>
  );
};

export default MyOccasions;
